"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var RESIZE_HANDLE_SIZE = 7;
var RESIZE_HANDLE_MARGIN = 3;
var Xs = ['w', '', 'e'];
var Ys = ['s', '', 'n'];
/**
 * @internal
 * The resize drag and drop handler
 */
exports.Resizer = {
    onDragStart: function (_a) {
        var editInfo = _a.editInfo;
        return (__assign({}, editInfo));
    },
    onDragging: function (_a, e, base, deltaX, deltaY) {
        var _b;
        var x = _a.x, y = _a.y, editInfo = _a.editInfo, options = _a.options;
        var ratio = base.widthPx > 0 && base.heightPx > 0 ? (base.widthPx * 1.0) / base.heightPx : 0;
        _b = rotateCoordinate(deltaX, deltaY, editInfo.angleRad), deltaX = _b[0], deltaY = _b[1];
        var horizontalOnly = x == '';
        var verticalOnly = y == '';
        var shouldPreserveRatio = !(horizontalOnly || verticalOnly) && (options.preserveRatio || e.shiftKey);
        var newWidth = horizontalOnly
            ? base.widthPx
            : Math.max(base.widthPx + deltaX * (x == 'w' ? -1 : 1), options.minWidth);
        var newHeight = verticalOnly
            ? base.heightPx
            : Math.max(base.heightPx + deltaY * (y == 'n' ? -1 : 1), options.minHeight);
        if (shouldPreserveRatio && ratio > 0) {
            newHeight = Math.min(newHeight, newWidth / ratio);
            newWidth = Math.min(newWidth, newHeight * ratio);
            if (newWidth < newHeight * ratio) {
                newWidth = newHeight * ratio;
            }
            else {
                newHeight = newWidth / ratio;
            }
        }
        editInfo.widthPx = newWidth;
        editInfo.heightPx = newHeight;
        return true;
    },
};
/**
 * @internal Calculate the rotated x and y distance for mouse moving
 * @param x Original x distance
 * @param y Original y distance
 * @param angle Rotated angle, in radian
 * @returns rotated x and y distances
 */
function rotateCoordinate(x, y, angle) {
    if (x == 0 && y == 0) {
        return [0, 0];
    }
    var hypotenuse = Math.sqrt(x * x + y * y);
    angle = Math.atan2(y, x) - angle;
    return [hypotenuse * Math.cos(angle), hypotenuse * Math.sin(angle)];
}
exports.rotateCoordinate = rotateCoordinate;
/**
 * @internal
 * Double check if the changed size can satisfy current width of container.
 * When resize an image and preserve ratio, its size can be limited by the size of container.
 * So we need to check the actual size and calculate the size again
 * @param editInfo Edit info of the image
 * @param preserveRatio Whether w/h ratio need to be preserved
 * @param actualWidth Actual width of the image after resize
 * @param actualHeight Actual height of the image after resize
 */
function doubleCheckResize(editInfo, preserveRatio, actualWidth, actualHeight) {
    var widthPx = editInfo.widthPx, heightPx = editInfo.heightPx;
    var ratio = heightPx > 0 ? widthPx / heightPx : 0;
    actualWidth = Math.floor(actualWidth);
    actualHeight = Math.floor(actualHeight);
    widthPx = Math.floor(widthPx);
    heightPx = Math.floor(heightPx);
    editInfo.widthPx = actualWidth;
    editInfo.heightPx = actualHeight;
    if (preserveRatio && ratio > 0 && (widthPx !== actualWidth || heightPx !== actualHeight)) {
        if (actualWidth < widthPx) {
            editInfo.heightPx = actualWidth / ratio;
        }
        else {
            editInfo.widthPx = actualHeight * ratio;
        }
    }
}
exports.doubleCheckResize = doubleCheckResize;
/**
 * @internal
 * Get HTML for resize handles at the corners
 */
function getCornerResizeHTML(_a) {
    var resizeBorderColor = _a.borderColor;
    var result = [];
    Xs.forEach(function (x) {
        return Ys.forEach(function (y) {
            return result.push((x == '') == (y == '') ? getResizeHandleHTML(x, y, resizeBorderColor) : null);
        });
    });
    return result;
}
exports.getCornerResizeHTML = getCornerResizeHTML;
/**
 * @internal
 * Get HTML for resize handles on the sides
 */
function getSideResizeHTML(_a) {
    var resizeBorderColor = _a.borderColor;
    var result = [];
    Xs.forEach(function (x) {
        return Ys.forEach(function (y) {
            return result.push((x == '') != (y == '') ? getResizeHandleHTML(x, y, resizeBorderColor) : null);
        });
    });
    return result;
}
exports.getSideResizeHTML = getSideResizeHTML;
function getResizeHandleHTML(x, y, borderColor) {
    var leftOrRight = x == 'w' ? 'left' : 'right';
    var topOrBottom = y == 'n' ? 'top' : 'bottom';
    var leftOrRightValue = x == '' ? '50%' : '0px';
    var topOrBottomValue = y == '' ? '50%' : '0px';
    var direction = y + x;
    return x == '' && y == ''
        ? {
            tag: 'div',
            style: "position:absolute;left:0;right:0;top:0;bottom:0;border:solid 1px " + borderColor + ";pointer-events:none",
        }
        : {
            tag: 'div',
            style: "position:absolute;" + leftOrRight + ":" + leftOrRightValue + ";" + topOrBottom + ":" + topOrBottomValue,
            children: [
                {
                    tag: 'div',
                    style: "position:relative;width:" + RESIZE_HANDLE_SIZE + "px;height:" + RESIZE_HANDLE_SIZE + "px;background-color: " + borderColor + ";cursor:" + direction + "-resize;" + topOrBottom + ":-" + RESIZE_HANDLE_MARGIN + "px;" + leftOrRight + ":-" + RESIZE_HANDLE_MARGIN + "px",
                    className: "r_resizeH" /* ResizeHandle */,
                    dataset: { x: x, y: y },
                },
            ],
        };
}
//# sourceMappingURL=Resizer.js.map